import styled from '@emotion/styled'
import { FlexBox } from 'app/components/Layout/FlexBox'
import { CompanyData } from 'app/containers/Footer/CompanyData'
import { styles, theme } from 'app/theme'
import { useVocabularyData } from 'app/utils/vocabulary'
import { rgba } from 'emotion-rgba'
import { uniqBy } from 'lodash'
import React, { memo } from 'react'

import { PolicyMenuItem, Props as PolicyMenuItemProps } from './PolicyMenuItem'

export interface Props {
  cin?: string
  companyEmail?: string
  companyName?: string
  email?: string
  languageCode: string
  phone?: string
  policyMenu?: { [key: string]: PolicyMenuItemProps[] }[]
  rea?: string
  registeredOffice?: string
  shareCapital?: string
  vat?: string
}

export const Bottom = memo(function Bottom({
  cin,
  companyEmail,
  companyName,
  email,
  languageCode,
  phone,
  policyMenu,
  rea,
  registeredOffice,
  shareCapital,
  vat,
}: Props) {
  return (
    <Container>
      <Box dial={1} row wrap>
        <CompanyData
          className="item-company"
          cin={cin}
          email={email}
          companyEmail={companyEmail}
          companyName={companyName}
          languageCode={languageCode}
          phone={phone}
          vat={vat}
          rea={rea}
          registeredOffice={registeredOffice}
          shareCapital={shareCapital}
        />

        {policyMenu ? (
          <>
            {uniqBy(policyMenu, 'title').map((item: any, index) => (
              <PolicyMenuItem key={index} {...item} />
            ))}
          </>
        ) : null}

        <Credits
          aria-label="QNT Hospitality"
          href="https://www.qnt.it"
          rel="noopenet"
          target="_blank"
        >
          {useVocabularyData('credits', languageCode)}
        </Credits>
      </Box>
    </Container>
  )
})

const Container = styled.div`
  position: relative;
  width: 100%;
  padding: 1.5rem 0 0;
  margin-top: 3.75rem;
  border-top: 0.125rem solid ${rgba(theme.colors.variants.primaryDark, 0.1)};

  @media (max-width: 1199px) {
    margin-top: 3rem;
    padding: 2.25rem 0 0 0;
  }
`

const Box = styled(FlexBox)`
  ${styles.label}

  color: ${theme.colors.variants.neutralDark1};
  gap: 2.25rem;

  @media (max-width: 1199px) {
    flex-direction: column;
    gap: 1.5rem;
  }
`

const Credits = styled.a`
  color: ${theme.colors.variants.neutralDark1};
  transition: 0.2s cubic-bezier(0.25, 1, 0.5, 1);

  &:hover {
    transition: 0.2s cubic-bezier(0.25, 1, 0.5, 1);
    opacity: 0.5;
  }
`
